import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem } from '@angular/material/list';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';
import { APP_LANGS, AppLang } from '../../../transloco-runtime';

export type LanguageSwitcherVariant = 'onPrimary' | 'primary';
/** 'icon' = globe icon button (auth screens, 404); 'menuItem' = text list item for the sidenav. */
export type LanguageSwitcherDisplay = 'icon' | 'menuItem';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.sass'],
  imports: [MatIconButton, MatIcon, MatListItem, MatMenu, MatMenuItem, MatMenuTrigger, MatTooltip, TranslocoDirective],
})
export class LanguageSwitcherComponent {
  private transloco = inject(TranslocoService);

  readonly variant = input<LanguageSwitcherVariant>('onPrimary');
  readonly display = input<LanguageSwitcherDisplay>('icon');
  readonly enabledLangs = APP_LANGS;
  readonly activeLang = toSignal(this.transloco.langChanges$, { initialValue: this.transloco.getActiveLang() });

  isActive(lang: AppLang): boolean {
    return this.transloco.getActiveLang() === lang;
  }

  async setLang(lang: AppLang): Promise<void> {
    if (this.enabledLangs.includes(lang)) {
      await firstValueFrom(this.transloco.load(lang));
      this.transloco.setActiveLang(lang);
    }
  }
}
